<template>
  <div ref="wrapper">
    <slot></slot>
  </div>
</template>

<script type="text/ecmascript-6">
  import BScroll from 'better-scroll'
  export default {
    props: {
      probeType: {
        type: Number,
        default: 3
      },
      data: {
        type: [Array, Number, Object],
        default: null
      },
      click: {
        type: Boolean,
        default: true
      },
      listenScroll: {
        type: Boolean,
        default: true
      },
      pullup: {
        type: Boolean,
        default: false
      },
      beforeScroll: {
        type: Boolean,
        default: false
      },
      refreshDelay: {
        type: Number,
        default: 20
      },
      bounce: {
        type: Boolean,
        default: true
      }
    },
    mounted () {
      setTimeout(() => {
        this._initScroll()
      }, 20)
    },
    methods: {
      // 初始化scroll
      _initScroll () {
        if (!this.$refs.wrapper) return
        // 初始化
        this.scroll = new BScroll(this.$refs.wrapper, {
          probeType: this.probeType,
          click: this.click,
          bounce: this.bounce
        })
        if (this.listenScroll) {
          let me = this
          this.scroll.on('scroll', pos => {
            me.$emit('scroll', pos)
          })
        }
        if (this.pullup) {
          this.scroll.on('scrollEnd', () => {
            if (this.scroll.y <= this.scroll.maxScrollY + 50) {
              this.$emit('scrollToEnd')
            }
          })
        }
        if (this.beforeScroll) {
          this.scroll.on('beforeScrollStart', () => {
            this.$emit('beforeScroll')
          })
        }
      },
      // 禁用scroll
      disable () {
        this.scroll && this.scroll.disable()
      },
      // 刷新scroll
      refresh () {
        this.scroll && this.scroll.refresh()
      },
      // 启用scroll
      enable () {
        this.scroll && this.scroll.enable()
      },
      // scroll滚动到指定元素
      scrollToElement () {
        this.scroll && this.scroll.scrollToElement.apply(this.scroll, arguments)
      },
      // scroll相对于当前位置移动
      scrollBy () {
        this.scroll && this.scroll.scrollBy.apply(this.scroll, arguments)
      }
    },
    watch: {
      // 监听列表数据，发生变化则刷新scroll
      data () {
        setTimeout(() => {
          // 防止右边滚动时点击左边菜单，右边不能滚动到底，可把延时时间设大点，或设置scrollTo(0, 0)
          this.scroll.scrollTo(0, 0)
          this.refresh()
        }, this.refreshDelay)
      }
    }
  }
</script>

